import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { components } from '@atlaskit/select';
import styled from 'styled-components';
import { AddOptionAvatar } from './AddOptionAvatar';
import { SizeableAvatar } from './SizeableAvatar';
import { messages } from './i18n';
import { getAvatarUrl, isEmail, isGroup } from './utils';
import PeopleIcon from '@atlaskit/icon/glyph/people';
export var scrollToValue = function scrollToValue(valueContainer, control) {
  var _valueContainer$getBo = valueContainer.getBoundingClientRect(),
      top = _valueContainer$getBo.top,
      height = _valueContainer$getBo.height;

  var _control$getBoundingC = control.getBoundingClientRect(),
      controlHeight = _control$getBoundingC.height;

  if (top - height < 0) {
    valueContainer.scrollIntoView();
  }

  if (top + height > controlHeight) {
    valueContainer.scrollIntoView(false);
  }
};
var GroupTagContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-left: 2px;\n"])));
var NameWrapper = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding-left: 5px;\n"])));
export var MultiValue = /*#__PURE__*/function (_React$Component) {
  _inherits(MultiValue, _React$Component);

  var _super = _createSuper(MultiValue);

  function MultiValue(props) {
    var _this;

    _classCallCheck(this, MultiValue);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getElemBefore", function () {
      var _this$props = _this.props,
          _this$props$data = _this$props.data,
          data = _this$props$data.data,
          label = _this$props$data.label,
          selectProps = _this$props.selectProps;

      if (isEmail(data)) {
        return selectProps.emailLabel ? /*#__PURE__*/React.createElement(AddOptionAvatar, {
          isLozenge: true,
          label: selectProps.emailLabel
        }) : /*#__PURE__*/React.createElement(FormattedMessage, messages.addEmail, function (label) {
          return /*#__PURE__*/React.createElement(AddOptionAvatar, {
            isLozenge: true,
            label: label
          });
        });
      }

      if (isGroup(data)) {
        return /*#__PURE__*/React.createElement(GroupTagContainer, null, /*#__PURE__*/React.createElement(PeopleIcon, {
          label: "group-icon",
          size: "small"
        }));
      }

      return /*#__PURE__*/React.createElement(SizeableAvatar, {
        appearance: "multi",
        src: getAvatarUrl(data),
        name: label
      });
    });

    _this.containerRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(MultiValue, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var isFocused = this.props.isFocused;

      if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) {
        scrollToValue(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props2 = this.props,
          _this$props2$data = _this$props2.data,
          label = _this$props2$data.label,
          data = _this$props2$data.data,
          innerProps = _this$props2.innerProps,
          isFocused = _this$props2.isFocused;
      var _nextProps$data = nextProps.data,
          nextLabel = _nextProps$data.label,
          nextData = _nextProps$data.data,
          nextInnerProps = nextProps.innerProps,
          nextIsFocused = nextProps.isFocused; // We can ignore onRemove here because it is a anonymous function
      // that will recreated every time but with the same implementation.

      return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          innerProps = _this$props3.innerProps,
          rest = _objectWithoutProperties(_this$props3, ["children", "innerProps"]);

      return /*#__PURE__*/React.createElement(components.MultiValue, _extends({}, rest, {
        innerProps: {
          ref: this.containerRef
        },
        cropWithEllipsis: false
      }), this.getElemBefore(), " ", /*#__PURE__*/React.createElement(NameWrapper, null, children));
    }
  }]);

  return MultiValue;
}(React.Component);